<script setup lang="ts">
import { computed } from 'vue';
import DateTimeBlock from '@/components/shared/blocks/DateTimeBlock.vue';
import PeopleBlock from '@/components/shared/blocks/PeopleBlock.vue';
import DescriptionBlock from '@/components/shared/blocks/DescriptionBlock.vue';
import { useBookingResourcesStore } from '@/stores/bookingResources';
import BaseOverlay from '@/overlays/BaseOverlay.vue';
import BlocksWrapper from '@/components/shared/blocks/BlocksWrapper.vue';

interface Props {
  booking: any;
}

const props = defineProps<Props>();

const bookingResourcesStore = useBookingResourcesStore();

const emit = defineEmits(['close-overlay']);

const resource = computed(() => {
  return bookingResourcesStore.all.find((resource: any) =>
    resource.bookings.find(
      (resourceBooking: any) => resourceBooking.id === props.booking.id
    )
  );
});
</script>

<template>
  <BaseOverlay @close="emit('close-overlay')" :title="resource?.title">
    <template #content>
      <BlocksWrapper>
        <DescriptionBlock :description="booking.description" />

        <DateTimeBlock :start="booking.start" :end="booking.end" />

        <PeopleBlock
          v-if="booking.participants.length"
          :profiles="booking.participants"
        />
      </BlocksWrapper>
    </template>
  </BaseOverlay>
</template>
